/**
 * Shared boilerplate for Payload's `live-preview` `requestHandler` option.
 * Payload's default handler uses `credentials: 'include'`; all of our handlers
 * omit credentials so public read works with local/dev CORS, then re-fetch the
 * doc as a GET (via method override) so drafts/relations resolve server-side.
 *
 * @param {(args: { serverURL: string, apiPath: string, docId: string|number }) => string} buildUrl
 *   Builds the collection URL (with any query params) for the live-edited doc.
 * @returns {(args: import('@payloadcms/live-preview').CollectionPopulationRequestHandlerArgs) => Promise<Response>}
 */
export function createLivePreviewRequestHandler(buildUrl) {
  return async function requestHandler({ apiPath, data, serverURL }) {
    const incoming = data?.data;
    const docId = incoming?.id;

    if (!docId) {
      return new Response(JSON.stringify(incoming ?? {}), {
        status: 200,
        headers: { "Content-Type": "application/json" },
      });
    }

    const url = buildUrl({ serverURL, apiPath, docId });
    return fetch(url, {
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "X-Payload-HTTP-Method-Override": "GET",
      },
      method: "POST",
    });
  };
}
